import BarcodeRequest from "../../libs/core-api-requests/dirs/barcodeRequest";
import { IDocumentInfoDTO } from "../../libs/coreapi-dto/@types/common";
import { IBarcodeDTO, IBarcodeViewDTO, IKizAllowResponse } from "../../libs/coreapi-dto/dirs/barcode";
import CoreApiService from "../../system/api/coreApiService";
import { playAlertSound } from "../../system/functions/beepSound";
import { DictionaryDataProvider } from "./Common";

export class BarcodeDataProvider extends DictionaryDataProvider<IBarcodeViewDTO, IBarcodeDTO> {
    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService;
    }

    getDataRequest(): Promise<BarcodeRequest> {
        return this._coreApiService.barcodeRequest;
    }

    allow(data: { barcode: string; document: IDocumentInfoDTO; idLot: string | null; type: string | null }, callback?: (response: IKizAllowResponse) => void) {
        this.getDataRequest().then((r) =>
            r.allow(data, (e) => {
                if (e.respType === "isCompleted") {
                    if (!e.data.isAllow) {
                        playAlertSound('danger')
                    }
                    callback?.(e.data);
                } else {
                    playAlertSound('danger')
                    throw new Error(e.message.title);
                }
            })
        );
    }
}
